module.exports = require('./helpers/bundle-url').getBundleURL('kcN7M') + "logo-dark.eefe0b7f.svg";